export const FLEX_ALIGN = Object.freeze({
  center: 'center',
  flexStart: 'flex-start',
});
